import {mapActions,mapGetters} from 'vuex'



export const mixins = {
    data() {
        return {
            tagBodyLeft: 0
        }
    },
    computed: {
        ...mapGetters('app/', [
            'tags'
        ])
    },
    methods: {
        ...mapActions('app/', [
            'close', 'open', 'clear', 'closeOther'
        ]),

        scroll(vm, e) {
            var type = e.type;
            let delta = 0;
            if (type === 'DOMMouseScroll' || type === 'mousewheel') {
                delta = (e.wheelDelta) ? e.wheelDelta : -(e.detail || 0) * 40;
            }
            let left = 0;
            if (delta > 0) {
                left = Math.min(0, vm.tagBodyLeft + delta);
            } else {
                if (vm.$refs.scrollCon.offsetWidth - 100 < vm.$refs.scrollBody.offsetWidth) {
                    if (vm.tagBodyLeft < -(vm.$refs.scrollBody.offsetWidth - vm.$refs.scrollCon.offsetWidth + 100)) {
                        left = vm.tagBodyLeft;
                    } else {
                        left = Math.max(vm.tagBodyLeft + delta, vm.$refs.scrollCon.offsetWidth - vm.$refs.scrollBody.offsetWidth - 100);
                    }
                } else {
                    vm.tagBodyLeft = 0;
                }
            }
            vm.tagBodyLeft = left;
        },
        handleOptions(btn) {
            switch (btn) {
                case "clear_all":
                    this.$router.push({
                        name: this.tags[0].name
                    })
                    this.clear();
                    break;
                default:
                    this.closeOther();
                    break;
            }
        },
        changeTag(item) {
            if (this.$route.name == item.name)
                return;
            this.open(item.name);
        },
        closeTag(item) {
            this.close(item);
            this.$router.push({
                name: this.current.name
            })

        },
        handleScroll(e) {
            this.scroll(this, e);
        }
    },
}